/**
 * <drop-countdown data-date="2026-10-15T10:00:00-0400">
 * Mono DD:HH:MM:SS countdown. Digits are zero-padded and the boxes are fixed-width (CSS),
 * so nothing shifts while it ticks. Hides itself when the date has passed.
 */
if (!customElements.get('drop-countdown')) {
  customElements.define(
    'drop-countdown',
    class DropCountdown extends HTMLElement {
      connectedCallback() {
        const raw = this.dataset.date || '';
        // Normalise "+0000" → "+00:00" so Safari parses the offset.
        const iso = raw.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
        this.target = new Date(iso).getTime();
        if (Number.isNaN(this.target)) {
          this.hidden = true;
          return;
        }

        // Build the markup when the element is empty, so a bare
        // <drop-countdown data-date="..."> works anywhere.
        if (!this.querySelector('[data-unit]')) this.render();

        this.fields = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };

        this.tick = this.tick.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.start();
      }

      render() {
        const labels = (this.dataset.labels || 'D,H,M,S').split(',');
        const units = ['days', 'hours', 'minutes', 'seconds'];
        this.classList.add('countdown');
        this.innerHTML = units
          .map(
            (unit, i) =>
              `<span class="countdown__unit"><span class="countdown__value" data-unit="${unit}">00</span><span class="countdown__label">${
                labels[i] || ''
              }</span></span>`
          )
          .join('<span class="countdown__sep" aria-hidden="true">:</span>');
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      onVisibility() {
        document.hidden ? this.stop() : this.start();
      }

      start() {
        this.tick();
        if (!this.timer) this.timer = setInterval(this.tick, 1000);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      tick() {
        const diff = this.target - Date.now();
        if (diff <= 0) {
          this.stop();
          this.hidden = true;
          this.dispatchEvent(new CustomEvent('drop-countdown:done', { bubbles: true }));
          return;
        }

        const total = Math.floor(diff / 1000);
        const days = Math.floor(total / 86400);
        const hours = Math.floor((total % 86400) / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;

        this.set('days', days);
        this.set('hours', hours);
        this.set('minutes', minutes);
        this.set('seconds', seconds);
      }

      set(unit, value) {
        const el = this.fields[unit];
        if (!el) return;
        const text = String(value).padStart(2, '0');
        if (el.textContent !== text) el.textContent = text;
      }
    }
  );
}
